import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCollapseAll = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m14.575 43.525-2.025-2L24 30.075l11.45 11.45-2.025 2L24 34.1zM24 17.875 12.55 6.425 14.575 4.4 24 13.825 33.425 4.4l2.025 2.025z" })
});
export default SvgCollapseAll;
